import { call, put } from 'redux-saga/effects'
import { TOO_MANY_REQUESTS } from 'src/constants/httpcodes'
import { fetchReviewsFailureAction, fetchReviewsSuccessAction } from './actions'
import { sendViewCommentsEvent } from 'client/contexts/Tracking/events'
import { sendTrackingRequestAction } from 'client/contexts/Tracking/actions'
import { fetchReviews, FetchReviewsPayload, FetchReviewsResponse } from './requests'
import { FETCH_REVIEWS_REQUEST, FETCH_REVIEWS_SUCCESS, FETCH_REVIEWS_FAILURE } from './constants'

interface FetchReviewsSagaPayload {
  type: typeof FETCH_REVIEWS_REQUEST | typeof FETCH_REVIEWS_SUCCESS | typeof FETCH_REVIEWS_FAILURE
  payload: FetchReviewsPayload
}

export function* fetchReviewsSaga(
  action: FetchReviewsSagaPayload
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Generator<any, void, FetchReviewsResponse> {
  try {
    const response = yield call(fetchReviews, action.payload)
    if (response.status === TOO_MANY_REQUESTS.status) {
      yield put(fetchReviewsFailureAction({ error: response.data.error.message })) // tripadvisor send a json with the error info
      return
    }

    yield put(sendTrackingRequestAction({ event: sendViewCommentsEvent(response.data) }))

    yield put(fetchReviewsSuccessAction(response.data))
  } catch (error) {
    yield put(fetchReviewsFailureAction({ error: (error as { message: string }).message }))
  }
}
